import React, { FC, useEffect, useCallback } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Typography, Theme } from '@mui/material'
import { useHistory, useParams } from 'react-router-dom'

import { TabsComponent } from '../../../components/Tabs'
import { tabList } from './tabList'
import { routes } from '../../../constants/routes'

const useStyles = makeStyles((theme: Theme) => ({
  topWrap: {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingTop: theme.spacing(4),
    '& p': {
      display: 'none',
    },
  },
  title: {
    paddingTop: theme.spacing(2),
  },
}))

export const Assets: FC = () => {
  const classes = useStyles()
  const history = useHistory()
  const { tab } = useParams<{ tab?: string }>()

  const handleTabChange = useCallback(
    (key: string) => {
      history.push(`${routes.SETTINGS_ASSETS}/${key}`)
    },
    [history],
  )

  useEffect(() => {
    const isValidTab = tabList.some((t) => t.slug === tab)
    if ((!tab || !isValidTab) && tabList.length > 0) {
      history.replace(`${routes.SETTINGS_ASSETS}/${tabList[0].slug}?page=1`)
    }
  }, [tab, history])

  return (
    <>
      <Grid container className={classes.topWrap}>
        <Typography variant="h1" className={classes.title}>
          Assets
        </Typography>
      </Grid>
      <TabsComponent tabList={tabList} activeTab={tab} onChangeTab={handleTabChange} />
    </>
  )
}
